module.exports = __webpack_public_path__ + "static/media/audio-description.811566e6.svg";